import { useTranslate } from "@tolgee/react";
import { AlertCircleIcon } from "lucide-react";
import { Button } from "#/components/ui/button";
import { cn } from "#/lib/utils";

type TableErrorStateProps = {
	message?: string;
	onRetry?: () => void;
	className?: string;
};

export function TableErrorState({
	message,
	onRetry,
	className,
}: TableErrorStateProps) {
	const { t } = useTranslate();

	return (
		<div
			className={cn(
				"flex flex-col items-center justify-center gap-2 py-8 text-center text-label2 text-muted-foreground",
				className,
			)}
		>
			<AlertCircleIcon className="size-5 opacity-70" />
			<p>{message ?? t("state.load-failed")}</p>
			{onRetry && (
				<Button variant="ghost" size="xs" onClick={onRetry}>
					{t("state.retry")}
				</Button>
			)}
		</div>
	);
}
